const messages = {
  operation_lane_busy: 'Систем завгүй байна, дахин оролдоно уу',
  operation_quarantined: 'Үйлдлийг хамгаалалтаар түгжсэн байна. Админаар шалгуулна уу',
  operation_not_completed: 'Үйлдэл дуусаагүй байна. Хадгалсан төлөвийг админаар шалгуулна уу',
  immutable_retry_conflict: 'Ижил түлхүүртэй үйлдлийн мэдээлэл зөрсөн байна. Админаар шалгуулна уу',
  operation_admission_closed: 'Үйлдэл хүлээн авах эрх хаалттай байна. Админд хандана уу',
  operation_writer_changed: 'Үйлдэл боловсруулах орчин өөрчлөгдсөн байна. Админд хандана уу',
  recovery_contention: 'Үйлдлийн төлөвийг сэргээх шаардлагатай байна. Админд хандана уу',
  operation_tenant_mismatch: 'Үйлдлийн клубын мэдээлэл зөрсөн байна',
  request_key_required: 'Үйлдлийн таних түлхүүр дутуу байна',
  operation_not_found: 'Үйлдлийн хадгалсан төлөв олдсонгүй. Админаар шалгуулна уу',
};

export const formatDurableError = code => {
  if (typeof code !== 'string' || !/^[a-zA-Z0-9_.-]{1,100}$/.test(code)) return null;
  return `${messages[code] || 'Үйлдэл амжилтгүй. Хадгалсан төлөвийг админаар шалгуулна уу'} [${code}]`;
};

export const requestBody = config => {
  try { return typeof config?.data === 'string' ? JSON.parse(config.data) : config?.data; }
  catch { return null; }
};

export const retainedRequestKey = config => {
  const headers = config?.headers;
  const body = requestBody(config);
  return headers?.get?.('Idempotency-Key') || headers?.['Idempotency-Key'] ||
    headers?.['idempotency-key'] || body?.operation_key || body?.idempotency_key;
};

export const durableRequest = (config, path) => {
  if (!['post', 'delete'].includes(config?.method?.toLowerCase())) return false;
  const body = requestBody(config);
  if (/^\/api\/quick-orders\/[^/]+\/items$/.test(path)) return true;
  if (/^\/api\/quick-orders\/[^/]+\/pay$/.test(path)) return body?.payment_method === 'credit';
  if (/^\/api\/sessions\/[^/]+\/pay$/.test(path)) return ['cash', 'card'].includes(body?.payment_method ?? 'cash');
  return /^\/api\/(?:orders\/[^/]+(?:\/return)?|quick-orders\/[^/]+\/items\/[^/]+|billing\/credits\/[^/]+\/repay|members\/[^/]+\/repay|products\/[^/]+\/adjust-stock|inventory\/(?:import(?:\/bulk)?|movement|count))$/.test(path);
};